import React from "react";

/**
 * Recursively extracts the text content from a React node.
 * @param node The React node to extract text from.
 * @returns The extracted text.
 */
export const getNodeText = (node: React.ReactNode): string => {
    if (node === null || node === undefined || typeof node === "boolean") {
        return "";
    }

    if (typeof node === "string" || typeof node === "number") {
        return `${node}`;
    }

    if (Array.isArray(node)) {
        return node.map(getNodeText).join("");
    }

    if (React.isValidElement(node)) {
        return getNodeText((node.props as { children?: React.ReactNode }).children);
    }

    return "";
};
